import axios from 'axios';

import {
    GET_OWNER_SERVICES,
    BLOCK_SERVICE_DATES,
    UNBLOCK_DATE,
    GET_ERRORS
} from './types';

import { API_ENDPOINT } from '../config/constants';

export const getOwnerServices = id => dispatch => {
    axios.get(API_ENDPOINT+`/owners/${id}/services`)
        .then(res => {
            dispatch({
                type: GET_OWNER_SERVICES,
                payload: res.data
            })
        })
        .catch(err =>
            dispatch({
                type: GET_ERRORS,
                payload: err.response.data
            })
        );
};

export const blockServiceDates = serviceInfo => dispatch => {
    const URL = serviceInfo.type === 'accommodation'
        ? API_ENDPOINT+`/booking/accomodations/${serviceInfo._id}`
        : API_ENDPOINT+`/booking/tours/${serviceInfo._id}`;

    axios.post(URL, serviceInfo)
        .then(res => {
            dispatch({
                type: BLOCK_SERVICE_DATES,
                payload: res.data
            });

            dispatch(getOwnerServices(res.data.ownerID));
        })
        .catch(err =>
            dispatch({
                type: GET_ERRORS,
                payload: err.response.data
            })
        );
};

export const unblockDate = dateToUnblock => dispatch => {
    const URL = API_ENDPOINT+`/owners/unblockDate`;

    axios.post(URL, dateToUnblock)
        .then(res => {
            dispatch({
                type: UNBLOCK_DATE,
                payload: res.data
            });

            dispatch(getOwnerServices(res.data.ownerID));
        })
        .catch(err =>
            dispatch({
                type: GET_ERRORS,
                payload: err.response.data
            })
        );
};


// WEBPACK FOOTER //
// ./src/actions/ownersActions.js